import { t } from 'i18next';

/**
 * Gets the error message feom i18n and it not defined there, returns null unlike the t function
 * @param {string} statusCode - The string representing the error
 * @returns {string | null} - The i18n text or null if not found
 */
const _t = statusCode => {
	const result = t(`errors.${statusCode}`);
	return result === `errors.${statusCode}` ? null : result;
};

/**
 * Return a proper error message based on the response object
 * @param {import('axios').AxiosResponse} res - The response object
 * @param {object} [options] - Some options that can customize how to show an error
 * @param {Object<string, string>} [options.errorMessages] - An object which can override error statusCode/message pair
 */
export const getErrorMessage = (res, options = { errorMessages: {} }) => {
	const statusCode = res?.data?.error?.statusCode || res?.data?.statusCode;

	let returnValue = options?.errorMessages?.[statusCode]
	|| _t(statusCode);

	if (returnValue) return returnValue;

	if (t('_language') === 'fa') return t('errors.default');

	return  res?.data?.message
		|| res?.data?.error?.message
		|| t('errors.default');
};